import React from 'react';

import {PasswordChange} from 'legacy_components/PasswordChange';
import {ProgressSpinner} from 'legacy_components/ProgressSpinner';
import {User} from 'legacy_components/User';
import {ClientCompanyExport} from 'legacy_components/ClientCompanyExport';
import styles from 'legacy_css_modules/Profile.module.css';

export const Profile = ({user,clientCompanies, ...props}) => {
    if (!user) {
        return <ProgressSpinner/>
    }
    
    return (
        <section className={styles.container}>
            <h1>Uživatelský účet</h1>
            <User user={user} {...props}/>
            <PasswordChange {...props}/>
            {user["role"] === "OrganizationUnitAdmin" && <ClientCompanyExport user={user} clientCompanies={clientCompanies} />
}
        </section>
    )
};